import { useState } from 'react'
import Modal from 'components/modal'
import DateRangeReportForm from 'components/dateRangeReportForm/dateRangeReportForm'
import { downloadOrderReport } from 'utils/api/orderApi'
import { generateBarcodeReportSchema } from 'utils/schema/generateBarcodeReportSchema'
import ExportRmaForm from './exportRmaSection'
import NullEmpIdOrdersForm from './nullEmpIdOrdersForm'
import ReportSubmitButton from './reportSubmitButton'
import StoreSalesReportForm from './storeSalesReportForm'

type Props = {
  isOpen: boolean
  closeModal: () => void
}

const REPORTS = [
  {
    key: 'notExistBarcode',
    label: 'Not Exist Barcode',
    render: () => (
      <DateRangeReportForm
        title="Not Exist Barcode Report"
        buttonText="Generate"
        validationSchema={generateBarcodeReportSchema}
        onSubmit={async (range: { from: string; to: string }) => {
          const { from, to } = range
          await downloadOrderReport({ filters: { from, to } })
        }}
        renderSubmit={(isSubmitting) => (
          <ReportSubmitButton loading={isSubmitting} />
        )}
      />
    ),
  },
  {
    key: 'storeSales',
    label: 'Store Sales',
    render: () => <StoreSalesReportForm />,
  },
  {
    key: 'exportRma',
    label: 'Export RMA',
    render: () => <ExportRmaForm />,
  },
  {
    key: 'nullEmpId',
    label: 'Null EmpId Orders',
    render: () => <NullEmpIdOrdersForm />,
  },
]

const OrderReportsModal = ({ isOpen, closeModal }: Props) => {
  const [activeKey, setActiveKey] = useState(REPORTS[0].key)

  const activeReport =
    REPORTS.find((report) => report.key === activeKey) ?? REPORTS[0]

  return (
    <Modal
      width={720}
      title="Reports"
      isOpen={isOpen}
      closeModal={closeModal}
      // leave room for the date pickers / multi-select dropdowns to open
      customStyle={{ minHeight: '480px' }}
    >
      <>
        {/* Report tabs */}
        <div className="mb-5 flex flex-wrap gap-2 border-b border-gray-200">
          {REPORTS.map((report) => (
            <button
              key={report.key}
              type="button"
              onClick={() => setActiveKey(report.key)}
              className={`-mb-px border-b-2 px-3 py-2 text-sm font-semibold ${
                report.key === activeKey
                  ? 'border-sidebar-primary text-sidebar-primary'
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
            >
              {report.label}
            </button>
          ))}
        </div>

        {/* Only the active form is mounted, so switching tabs resets it */}
        <div key={activeReport.key}>{activeReport.render()}</div>
      </>
    </Modal>
  )
}

export default OrderReportsModal
